<div class='centerContent'>
    <img src='assets/images/error.png' alt='...' class='img-responsive' width='50%' height="50%" />
</div>